import { combineReducers } from 'redux';
import admin from './admin/reducers';
import auth from './auth/reducers';
import bookings from './bookings/reducers';
import calendarSource from './calendar-source/reducers';
import commission from './commission-breakdown/reducers';
import channels from './contracts/reducers';
import directDiscounts from './direct-discounts/reducers';
import pendingEventNotes from './event-notes/reducers';
import events from './events/reducers';
import flags from './flags/reducers';
import images from './images/reducers';
import listings from './listings/reducers';
import policies from './policies/reducers';
import pendingPostPayments from './post-payment/reducers';
import pricing from './pricing/reducers';
import quality from './quality/reducers';
import redirect from './redirect/reducers';

export interface IEntitiesState {
	admin: ReturnType<typeof admin>;
	auth: ReturnType<typeof auth>;
	bookings: ReturnType<typeof bookings>;
	calendarSource: ReturnType<typeof calendarSource>;
	commission: ReturnType<typeof commission>;
	pendingEventNotes: ReturnType<typeof pendingEventNotes>;
	channels: ReturnType<typeof channels>;
	directDiscounts: ReturnType<typeof directDiscounts>;
	pricing: ReturnType<typeof pricing>;
	events: ReturnType<typeof events>;
	flags: ReturnType<typeof flags>;
	images: ReturnType<typeof images>;
	policies: ReturnType<typeof policies>;
	quality: ReturnType<typeof quality>;
	listings: ReturnType<typeof listings>;
	redirect: ReturnType<typeof redirect>;
	pendingPostPayments: ReturnType<typeof pendingPostPayments>;
}

export default combineReducers<IEntitiesState>({
	admin,
	auth,
	bookings,
	calendarSource,
	commission,
	pendingEventNotes,
	channels,
	directDiscounts,
	events,
	flags,
	images,
	policies,
	pricing,
	quality,
	redirect,
	listings,
	pendingPostPayments
});
